<template>
  <div class="login" v-title data-title="北京天蔚中医药发展促进中心-登录">
    <section class="form_container">
      <el-form
        :model="loginUser"
        :rules="rules"
        ref="loginForm"
        class="loginForm"
        label-width="70px"
        style="margin-top:30px;padding-top:30px"
      >
        <el-form-item>
          <div class="login_title">
            <img src="../assets/logo.png" alt />
            <h1>北京天蔚中医药发展促进中心</h1>
            <p>BEIJING TIANWEI PROMOTION CENTER</p>
            <div class="line"></div>
          </div>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input
            clearable
            :input="isClickPhone()"
            v-model="loginUser.phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="verifyCode">
          <div style="display: flex;justify-content: space-between;">
            <el-input
              style="width:1.6rem"
              v-model="loginUser.verifyCode"
              placeholder="请输入验证码"
              type="text"
              clearable
            ></el-input>
            <el-button
              v-if="!disabled"
              type="primary"
              style="width:1.1rem;"
              @click="getVerifyCode(loginUser.phone)"
              >发送验证码</el-button
            >
            <span style="width:1.1rem;" v-else>{{ btnTitle }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            :type="!isClick ? 'primary' : 'info'"
            :disabled="isClick"
            @click="submitForm('loginForm')"
            class="submit_btn"
            >登 录 / 注 册</el-button
          >
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
// import jwt_decode from "jwt-decode";
import { mapState } from "vuex"
import {
  Login,
  nextPassword,
  editPassword,
  getReCode,
  getBackCode,
} from "@/api/user.js"
export default {
  name: "login",
  data() {
    return {
      loginUser: {
        phone: "",
        verifyCode: "",
      },
      btnTitle: "",
      disabled: false,
      isClick: false,
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "手机号不符合要求", trigger: "blur" },
        ],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 6, max: 6, message: "验证码不符合要求", trigger: "blur" },
        ],
      },
    }
  },
  methods: {
    // 登录样式
    isClickPhone() {
      if (
        this.isCellPhone(this.loginUser.phone) &&
        this.isVerifyCode(this.loginUser.verifyCode)
      ) {
        this.isClick = false
      } else {
        this.isClick = true
      }
    },
    // 登录注册
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let userInfo = new FormData()
          userInfo.append("phone", this.loginUser.phone)
          userInfo.append("mobile_code", this.loginUser.verifyCode)
          let loginInfo = await Login(userInfo)
          if (loginInfo.code == "One") {
            if (loginInfo.phoneuser.status == 1) {
              this.$message.warning("当前用户正在审核中，请耐心等候")
            } else {
              this.$router.push({
                name: "register",
                params: { phone: loginInfo.phoneuser.phone },
              })
            }
          } else if (loginInfo.code == "OK") {
            this.$store.commit("user/getUserInfo", loginInfo.user)
            let flag = navigator.userAgent.match(
              /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            )
            if (flag) {
              this.$router.push("/mmain")
            } else {
              this.$router.push("/")
            }
          } else if (loginInfo.code == "ERR") {
            this.$message.error(loginInfo.msg)
          }
          // 登录成功
          // const { token } = res.data;
          // localStorage.setItem("eleToken", res.data.token);
          // // 解析token
          // // const decode = jwt_decode(token);
          // // 存储数据
          // // this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
          // this.$store.commit("SET_IS_AUTNENTICATED", true);
          // // this.$store.dispatch("setIsAutnenticated");
          // this.$store.dispatch("setUser", res.data);
          // // 页面跳转
          // this.$router.push("/home");
        }
      })
    },
    // 获取验证码
    async getVerifyCode(phone) {
      if (this.isCellPhone(phone)) {
        this.validateBtn()
        // 发送网络请求
        let verifyCode = new FormData()
        verifyCode.append("phone", phone)
        let code = await getReCode(verifyCode)
        if (code.code == "ERR") {
          this.$message({
            type: "error",
            message: code.msg,
          })
        } else {
          this.$message({
            type: "success",
            message: "验证码已发送",
          })
        }
      } else {
        this.$message({
          type: "warning",
          message: "手机号有误",
        })
      }
    },
    //验证手机号格式
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false
      } else {
        return true
      }
    },
    //验证验证码
    isVerifyCode(val) {
      if (!/\d{6}$/.test(val) || val.length !== 6) {
        return false
      } else {
        return true
      }
    },
    //倒计时
    validateBtn() {
      let time = 60
      this.disabled = true
      this.btnTitle = time + "秒后重试"
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer)
          this.disabled = false
        } else {
          // 倒计时
          time--
          this.btnTitle = time + "秒后重试"
          this.disabled = true
        }
      }, 1000)
    },
    isEmpty(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
      )
    },
  },
}
</script>

<style lang="less" scoped>
.login {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: url(../assets/newBg.png) no-repeat center center;
  background-size: 100% 100%;
  .form_container {
    width: 420px;
    position: absolute;
    top: 15%;
    left: calc(50vw - 235px);
    padding: 25px;
    border-radius: 5px;
    text-align: center;
    .loginForm {
      margin-top: 20px;
      background-color: #fff;
      padding: 20px 60px 30px 0;
      border-radius: 5px;
      box-shadow: 0px 5px 10px #cccc;
      .login_title {
        img {
          width: 50px;
          height: 50px;
        }
        h1 {
          font-size: 18px;
          font-weight: 600;
          margin: -10px 0 0px;
        }
        p {
          margin-bottom: 26px;
          font-size: 11px;
          line-height: 1;
          color: #3d3d3d;
        }
        .line {
          height: 1px;
          background-color: #e5e5e5;
          width: 100%;
          margin-bottom: 20px;
        }
      }
      .submit_btn {
        width: 100%;
      }
    }
  }
}
</style>
